import React from "react";
import "./tabs.scss";

const Tab = ({ activeTab, nextTab, label, id, className, onClick }) => {
  const getClassName = () => {
    let tabClassName = `dcrfrom-tabs__option ${className}`;
    if (activeTab === id) {
      tabClassName = tabClassName + " dcrfrom-tabs__option--active";
    }
    if (activeTab !== nextTab && nextTab === id) {
      tabClassName = tabClassName + " dcrfrom-tabs__option--next";
    }
    return tabClassName;
  };

  const handleClick = () => onClick(id);

  return (
    <li className={getClassName()} onClick={handleClick}>
      {label}
    </li>
  );
};

const Tabs = ({
  className = "dcrfrom-tabs",
  nextTab,
  children,
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className={className}>
      <ol className="dcrfrom-tabs__options">
        {children.map((child) => {
          const { label, className, id } = child.props;
          return (
            <Tab
              activeTab={activeTab}
              nextTab={nextTab}
              key={id}
              label={label}
              id={id}
              className={className}
              onClick={setActiveTab}
            />
          );
        })}
      </ol>
      <div className="dcrfrom-tabs__content">
        {children.map((child) => {
          if (child.props.id === activeTab) {
            return child.props.children;
          }
        })}
      </div>
    </div>
  );
};

export default Tabs;
